module.exports = __webpack_public_path__ + "media/images/subs_logo_bespoke-e052e0469b56ee2cc243731d1d28d827.png";